import { render } from "./ForgotPasswordSuccessView.vue?vue&type=template&id=6ff409d4"
import script from "./ForgotPasswordSuccessView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSuccessView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__